<!-- Контур ТС для подсказки ракурса из дизайн-исходника vehicle_inspection/source/truck_art.py. -->
<template>
  <svg
    class="vehicle-inspection-illustration"
    :class="{ 'vehicle-inspection-illustration--mirrored': code === 'right' }"
    :viewBox="viewBox"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="code === 'front'">
      <path d="M30 7 Q50 1 70 7"/><path d="M22 52 V15 Q22 7 30 7 H70 Q78 7 78 15 V52 Z"/>
      <path d="M27 13 H73 L71 29 H29 Z"/><rect x="34" y="34" width="32" height="13" rx="2"/>
      <path d="M37 38.5 H63 M37 42.5 H63"/><rect x="19" y="50" width="62" height="7" rx="2"/>
      <rect x="24" y="57" width="10" height="11" rx="2"/><rect x="66" y="57" width="10" height="11" rx="2"/>
    </template>
    <template v-else-if="code === 'back'">
      <path d="M28 9 Q50 3 72 9"/><rect x="26" y="9" width="48" height="29" rx="4"/>
      <path d="M33 16 H67 M30 42 Q50 36 70 42 V45 H30 Z"/><rect x="19" y="52" width="62" height="5" rx="1.5"/>
      <rect x="14" y="57" width="9" height="12" rx="2"/><rect x="77" y="57" width="9" height="12" rx="2"/>
    </template>
    <template v-else-if="code === 'cabin'">
      <path d="M6 6 H94 L86 26 H14 Z"/><path d="M4 38 Q50 28 96 38 V44 H4 Z"/>
      <rect x="56" y="34" width="18" height="7" rx="1.5"/><circle cx="32" cy="50" r="13"/>
      <circle cx="32" cy="50" r="3.5"/><path d="M19 50 H28.5 M35.5 50 H45 M32 53.5 V63"/>
    </template>
    <template v-else-if="code === 'dashboard'">
      <rect x="6" y="10" width="88" height="54" rx="12"/><circle cx="30" cy="36" r="15"/>
      <path d="M30 36 L39 28"/><circle cx="70" cy="36" r="15"/><path d="M70 36 L62 27"/>
      <rect x="40" y="50" width="20" height="8" rx="2"/>
    </template>
    <template v-else>
      <path d="M18 7 Q34 1 54 5"/><path d="M8 50 V17 Q8 7 18 7 H56 Q62 7 62 13 V50 H41 A13 13 0 0 0 19 50 Z"/>
      <path d="M14 13 H36 V30 H11 V17 Q11 13 14 13 Z M40 11 V46 M62 40 H154 V46 H62"/>
      <circle cx="30" cy="58" r="10"/><circle cx="112" cy="58" r="10"/><circle cx="136" cy="58" r="10"/>
    </template>
  </svg>
</template>

<script>
export default {
  name: "VehicleInspectionVehicleIllustration",
  props: { code: { type: String, required: true } },
  computed: {
    viewBox() {
      return ["left", "right"].includes(this.code) ? "0 0 160 72" : "0 0 100 72";
    },
  },
};
</script>

<style scoped>
.vehicle-inspection-illustration {
  width: min(72vw, 260px);
  max-height: 190px;
  color: color-mix(in srgb, var(--color-dark) 78%, var(--color-light));
}

.vehicle-inspection-illustration--mirrored {
  transform: scaleX(-1);
}
</style>
